import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var productCareIronLowIfNeededIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.948 3.616a2.336 2.336 0 0 1 2.336 2.336v14.431H1.2c-.327 0-.484-.292-.485-.619-.008-3.393 1.82-6.445 3.96-7.919 2.299-1.58 4.9-2.579 7.237-2.579h9.87V5.951a.835.835 0 0 0-.834-.835H10.735A1.003 1.003 0 0 1 9.73 4.113v-.497Zm.836 7.15h-9.871c-3.382 0-9.31 2.712-9.815 8.117h19.686v-8.117Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.342 14.995c0 .745-.606 1.357-1.354 1.357a1.358 1.358 0 0 1-1.354-1.357c0-.75.605-1.351 1.354-1.351a1.35 1.35 0 0 1 1.354 1.35"
})));

export { productCareIronLowIfNeededIcon as default };
//# sourceMappingURL=productCareIronLowIfNeededIcon.js.map
